module.exports = __webpack_public_path__ + "img/1493581509.92406b7a.jpg";